import { render, staticRenderFns } from "./grossing-touch-sample-tab-macroscopy.vue?vue&type=template&id=a1332e82&"
import script from "./grossing-touch-sample-tab-macroscopy.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-tab-macroscopy.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-tab-macroscopy.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports